import React, { useRef, useState } from 'react'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import NewClaimReport from './NewClaimReport'

import { parse } from 'date-fns'

const EditReportModal = ({ isEditReportOpen, setEditReportOpen, reportData }) => {
  const refForm = useRef('button')
  const [buttonLoading, setButtonLoading] = useState(false)
  const handleEditReportClose = () => {
    setEditReportOpen(false)
  }
  const customHeader = (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      columnGap={10}
      padding={{ xs: 2, lg: 3 }}
    >
      <Box>
        <Typography variant="h4" fontWeight="bold" color="dark-text.main">
          Edit {reportData?.title}
        </Typography>
      </Box>
      <Box onClick={handleEditReportClose} sx={{ cursor: 'pointer' }}>
        <Icon sx={{ color: 'dark-text.main' }}>close_rounded</Icon>
      </Box>
    </Box>
  )

  return (
    <AdxFormModal
      open={isEditReportOpen}
      handleClose={handleEditReportClose}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          handleEditReportClose()
        }
      }}
      disableAutoFocus
      title={<> Edit {reportData?.title}</>}
      enableFooter
      actionText="Save Report"
      handleAction={() => refForm.current.handleSubmit()}
      actionButtonDisabled={refForm?.current?.isSubmitting}
      cancelText="Cancel"
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      >
        <NewClaimReport
          setButtonLoading={setButtonLoading}
          ref={refForm}
          reportData={{
            id: reportData?.id,
            title: reportData?.title,
            claimReportType: reportData?.claim_report_type === 'Personal' ? 1 : 2,
            description: reportData?.description,
            startDate: parse(reportData?.start_date, 'dd/MM/yyyy', new Date()),
            endDate: parse(reportData?.end_date, 'dd/MM/yyyy', new Date()),
          }}
          handleEditReportClose={handleEditReportClose}
        />
        {/* <Box
          width={1}
          display="flex"
          flexDirection={{ xs: 'column-reverse', lg: 'row' }}
          justifyContent="center"
          alignContent="center"
          sx={{ gap: 1 }}
        >
          <AdxButton variant={'ghost'} onClick={handleEditReportClose}>Cancel</AdxButton>
          <AdxButton
            sx={{ width: { xs: 1, lg: 3 / 5 }, marginBottom: { xs: 1, lg: 0 } }}
            onClick={() => refForm.current.handleSubmit()}
            disabled={refForm?.current?.isSubmitting}
          >
            Save report
          </AdxButton>
        </Box> */}
      </Box>
    </AdxFormModal>
  )
}

export default EditReportModal
